import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, orderBy, getDocs } from "firebase/firestore";
import momentjs from 'moment';
import { useState, useEffect } from 'react';

const useChatList = () => {
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const firebaseConfig = {
        apiKey: "AIzaSyD0dRAy30uqOBPB8TG2Yt3MtGr5d07Dy5E",
        authDomain: "pnp-programa-nutricional.firebaseapp.com",
        databaseURL: "https://pnp-programa-nutricional.firebaseio.com",
        projectId: "pnp-programa-nutricional",
        storageBucket: "pnp-programa-nutricional.appspot.com",
        messagingSenderId: "739635922755",
        appId: "1:739635922755:web:49c1c5ec2ae5e18e5651f6",
        measurementId: "G-6Q2W3E05HV"
    };
    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);

    const db = getFirestore(firebaseApp);

    const getChats = async () => {
        try {
            setLoading(true);
            const q = query(collection(db, "users"), orderBy("last_message", "desc"));
            const querySnapshot = await getDocs(q);
            const chats = setChats(querySnapshot.docs.map((doc) => ({
                id: doc.id,
                nome: doc.data().user_name,
                data: momentjs(doc.data().last_message.toDate()).format('DD/MM/YYYY'),
                userRef: doc,
                unread_messages: doc.data().unread_messages || 0,
                was_read_adm: doc.data().was_read_adm,
                photo_url: doc.data().photo_url,
                stage: doc.data().stage
            })));
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    }

    useEffect(() => {
        getChats();
    }, []);

    return { chats, loading, error };
}

export { useChatList }